// extracted by mini-css-extract-plugin
export var container = "_54-1";
export var cornerButtonContainer = "_54-5";
export var disabled = "_54-2";
export var fileContainer = "_54-4";
export var hiddenInput = "_54-3";
export var widthContainer = "_54-0";